import Request from '../../common/api/request';
import ServiceResultFactory from '../../common/api/ServiceResultFactory';
import Utils from '../../common/Utils';
import AuthorizationStore from '../../common/api/authorizationStore';

const graphqlUrl = baseUrl => (
  `${baseUrl}graphql`
);


const getFeatureFilters = (baseApiUrl, eventEditionId, interfaceLocale) => {
  const authToken = AuthorizationStore.getToken();
  return authToken.then((token) => {
    if (token === '' || token === undefined) {
      const res = {
        status: 200,
        body: {
          data: { participantFeatureFilters: null },
          errors: [{ message: 'No token found in cookie. Please log in.', extensions: { code: 'unauthorized' } }]
        }
      };
      return new Promise((resolutionFunc) => {
        resolutionFunc(ServiceResultFactory.fromGraphqlSuccess(res, interfaceLocale, 'participantFeatureFilters'));
      });
    }

    const userId = Utils.parseJwt(token).sub;
    const query =
  `query{
      participantFeatureFilters(eventEditionId:"${eventEditionId}", userId:"${userId}"){
        featureFilterId
        multilingualNames{
          name,
          locale
        }
      }
    }`;
    return Request.graphqlRequest(graphqlUrl(baseApiUrl), query)
      .then(response => ServiceResultFactory.fromGraphqlSuccess(response, interfaceLocale, 'participantFeatureFilters'))
      .catch(result => ServiceResultFactory.fromError(interfaceLocale, result));
  });
};

const getFeatureFilterName = (baseApiUrl, eventEditionId, interfaceLocale) => {
  const authToken = AuthorizationStore.getToken();
  return authToken.then((token) => {
    if (token === '' || token === undefined) {
      const res = {
        status: 200,
        body: {
          data: { featureFilters: null },
          errors: [{ message: 'No token found in cookie. Please log in.', extensions: { code: 'unauthorized' } }]
        }
      };

      return new Promise((resolutionFunc) => {
        resolutionFunc(ServiceResultFactory.fromGraphqlSuccess(res, interfaceLocale, 'featureFilters'));
      });
    }
    const query =
        `query{
    featureFilters(eventEditionId: "${eventEditionId}",
            locale: "${interfaceLocale}") 
 {
  items{
      id,
      multilingualNames{
        name,
        locale
      }
  }
 }
}`;
    return Request.graphqlRequest(graphqlUrl(baseApiUrl), query)
        .then(response => ServiceResultFactory.fromGraphqlSuccess(response, interfaceLocale, 'featureFilters'))
        .catch(result => ServiceResultFactory.fromError(interfaceLocale, result));
  });
};

export default {
  getFeatureFilters, getFeatureFilterName
};

